import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useGetDistributorData() {
  const [loading, setLoading] = useState(false);

  async function execute(distributorId: string) {
    try {
      setLoading(true);
      const response = await api.get(
        `v1/backoffice/distributors/${distributorId}`,
      );

      if (response.status === 200) {
        return response.data;
      }
    } catch (error: any) {
      const errorData = error.response.data;

      if (!Array.isArray(errorData.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        errorData.message.map((err: string) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
